export default function tabs() {
    let acc = document.getElementsByClassName('js-tabs-open'), i;

    for(i = 0; i < acc.length; i++) {
        //when one of the buttons are clicked run this function
        acc[i].onclick = function(e) {
            e.preventDefault();
            //variables
            let panel = this.closest('.js-tabs-head').nextElementSibling,
                head = this.closest('.js-tabs-head'),
                coursePanel = document.getElementsByClassName('js-tabs-desc'),
                courseTabActive = document.getElementsByClassName('js-tabs-open active');

            /*if pannel is already open - minimize*/
            if(panel.style.maxHeight) {
                //minifies current pannel if already open
                panel.style.maxHeight = null;
                //removes the 'active' class as toggle didnt work on browsers minus chrome
                this.classList.remove('active');
                head.classList.remove('active');
                panel.classList.remove('active');
            } else { //pannel isnt open...
                //goes through the buttons and removes the 'active' css (+ and -)
                for(let j = 0; j < courseTabActive.length; j++) {
                    courseTabActive[j].classList.remove('active');
                }
                //Goes through and removes 'activ' from the css, also minifies any 'panels' that might be open
                for(let k = 0; k < coursePanel.length; k++) {
                    this.classList.remove('active');
                    head.classList.remove('active');
                    panel.classList.remove('active');
                    coursePanel[k].style.maxHeight = null;
                }
                //opens the specified pannel
                panel.style.maxHeight = `${panel.scrollHeight}px`;
                //adds the 'active' addition to the css.
                this.classList.add('active');
                head.classList.add('active');
                panel.classList.add('active');
            }
        };
    }
}
